import { render } from "./PuestoList.vue?vue&type=template&id=65ab2d3b&scoped=true"
import script from "./PuestoList.vue?vue&type=script&lang=js"
export * from "./PuestoList.vue?vue&type=script&lang=js"

import "./PuestoList.vue?vue&type=style&index=0&id=65ab2d3b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ab2d3b"]])

export default __exports__